module.exports = __webpack_public_path__ + "img/left-lightning8.5053b9cb.png";